import {
  Box,
  Button,
  Card,
  CardBody,
  CardFooter,
  Divider,
  Flex,
  HStack,
  Image,
  List,
  ListItem,
  Text,
  VStack,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import {
  FursatookImageGallery,
  GALLERY_LAYOUTS,
} from "../image-gallery";
import { useEffect, useState } from "react";
import { ACCOMMODATION_TYPES, CURRENCY_SYMBOLS } from "../../constants";

const RoomCard = ({
  room,
  type: accommodationType,
  onSelect,
  previewOnly,
  isForTour,
}) => {
  const {
    name,
    bedCount,
    capacity,
    facilities,
    images,
    pricePerNight,
    unitCount,
    recommendedPricePerDay,
  } = room;
  const { t, i18n } = useTranslation(["accommodation", "common"]);
  const [numberOfRoomsToSelect, setNumberOfRoomsToSelect] = useState(0);
  const [invokeOnRoomSelect, setInvokeOnRoomSelect] = useState(false);

  const [numberOfRoomsToSelectForTour, setNumberOfRoomsToSelectForTour] =
    useState(0);

  useEffect(() => {
    if (invokeOnRoomSelect) {
      onSelect(numberOfRoomsToSelect);
      setInvokeOnRoomSelect(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [invokeOnRoomSelect]);

  let qurrencySymbol = "";
  if (localStorage.getItem("currencyCode") === null)
    qurrencySymbol = CURRENCY_SYMBOLS["eu"];

  for (const code in CURRENCY_SYMBOLS) {
    if (code === localStorage.getItem("currencyCode")) {
      qurrencySymbol = CURRENCY_SYMBOLS[code];
      break;
    }
  }

  return (
    <Card variant="outline" borderRadius="12px">
      {(accommodationType === ACCOMMODATION_TYPES.HOTEL || isForTour) && (
        <FursatookImageGallery
          layout={GALLERY_LAYOUTS.room}
          images={images}
          isRTL={i18n.language === "ar"}
        />
      )}
      <CardBody padding={3} fontSize="small" minH={240}>
        <Text fontSize="xl" fontWeight="bold">
          {accommodationType === ACCOMMODATION_TYPES.HOTEL || isForTour
            ? name
            : t(accommodationType)}
        </Text>
        <HStack alignItems="flex-start" spacing={2} my={3}>
          <Image
            boxSize="16px"
            src={require("../../assets/single-bed-icon.svg").default}
          />
          <Text>{bedCount}</Text>
        </HStack>
        <HStack alignItems="flex-start" spacing={2} my={3}>
          <Image
            boxSize="16px"
            src={require("../../assets/two-people.svg").default}
          />
          <Text>{t("roomSleepsCapacity", { count: capacity })}</Text>
        </HStack>
        <List>
          {facilities?.split(",").map((facility, index) => (
            <ListItem key={index} fontSize="sm" mb={2}>
              · {facility.trim()}
            </ListItem>
          ))}
        </List>
      </CardBody>
      <Divider />
      <CardFooter justify="space-between" alignItems="center" padding={3}>
        <Box>
          <VStack alignItems={"left"}>
            <HStack>
              <Text as="span" fontWeight="bold" fontSize="large">
                {recommendedPricePerDay !== undefined &&
                recommendedPricePerDay !== null
                  ? `${qurrencySymbol} ${parseFloat(
                      recommendedPricePerDay.replace(/[^0-9.-]+/g, "")
                    ).toFixed(2)}`
                  : pricePerNight}
              </Text>
              <Text as="span" fontSize="sm">
                {"/"}
                {t("common:perNightLabel")}
              </Text>
            </HStack>
            {unitCount !== undefined && unitCount !== null && (
              <Text fontSize="sm">
                {t("forRoomsCount", { count: unitCount })}
              </Text>
            )}
            {accommodationType !== ACCOMMODATION_TYPES.HOTEL && (
              <Text fontSize="sm">
                {t("forEntireAccommodation", {
                  type: t(accommodationType),
                })}
              </Text>
            )}
          </VStack>
        </Box>
        {!previewOnly && (
          <Flex gap={2}>
            {accommodationType === ACCOMMODATION_TYPES.HOTEL && !isForTour && (
              <HStack spacing={2}>
                <Button
                  isDisabled={numberOfRoomsToSelect === 0}
                  onClick={() => {
                    setNumberOfRoomsToSelect(numberOfRoomsToSelect - 1);
                    setInvokeOnRoomSelect(true);
                  }}
                  colorScheme="teal"
                  variant="outline"
                >
                  -
                </Button>
                <Text w="20px" align="center">
                  {numberOfRoomsToSelect}
                </Text>
                <Button
                  onClick={() => {
                    setNumberOfRoomsToSelect(numberOfRoomsToSelect + 1);
                    setInvokeOnRoomSelect(true);
                  }}
                  colorScheme="teal"
                  variant="outline"
                >
                  +
                </Button>
              </HStack>
            )}
            {isForTour && accommodationType === ACCOMMODATION_TYPES.HOTEL && (
              <>
                <HStack spacing={2}>
                  <Button
                    isDisabled={numberOfRoomsToSelectForTour === 0}
                    onClick={() => {
                      setNumberOfRoomsToSelectForTour(
                        numberOfRoomsToSelectForTour - 1
                      );
                    }}
                    colorScheme="teal"
                    variant="outline"
                  >
                    -
                  </Button>
                  <Text w="20px" align="center">
                    {numberOfRoomsToSelectForTour}
                  </Text>
                  <Button
                    onClick={() => {
                      setNumberOfRoomsToSelectForTour(
                        numberOfRoomsToSelectForTour + 1
                      );
                    }}
                    colorScheme="teal"
                    variant="outline"
                  >
                    +
                  </Button>
                </HStack>
              </>
            )}

            {isForTour && (
              <Button
                isDisabled={
                  accommodationType === ACCOMMODATION_TYPES.HOTEL &&
                  numberOfRoomsToSelectForTour === 0
                }
                colorScheme="teal"
                variant="solid"
                onClick={() => {
                  if (accommodationType !== ACCOMMODATION_TYPES.HOTEL)
                    onSelect(1);
                  else onSelect(numberOfRoomsToSelectForTour);
                }}
              >
                {t("common:selectButtonText")}
              </Button>
            )}
          </Flex>
        )}
      </CardFooter>
    </Card>
  );
};

export default RoomCard;
